/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserContactResponseDto } from '../../models/get-user-contact-response-dto';

export interface GetUserContactByUserId$Params {
  user_id: string;
}

export function getUserContactByUserId(
  http: HttpClient,
  rootUrl: string,
  params: GetUserContactByUserId$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<GetUserContactResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getUserContactByUserId.PATH, 'get');
  if (params) {
    rb.path('user_id', params.user_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserContactResponseDto>;
    })
  );
}

getUserContactByUserId.PATH = '/v2/users/{user_id}/contact';
